<!-- Weather cards start -->
<section id="weather-examples">
  <div class="col-12" style="display: flex;justify-content: space-between;">
    <div class="col-md-4">
      <h4 *ngIf="totalItems" class="card-title dark mt-6">Total : <span style="font-size: medium;">{{ totalItems }}</span></h4>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <ng-select [items]="jobTags" bindLabel="name" bindValue="_id" placeholder="Select job location" (change)="getBusinessListByType()" [(ngModel)]="jobTag_id">
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-md-4" *ngFor="let item of business">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-img">
            <img class="card-img-top img-fluid" src="assets/img/job.png" alt="Card image cap" />
            <div class="card-img-overlay">
              <h4 class="card-title dark mt-6">{{ item.name }}</h4>
            </div>
            <!-- <a class="btn btn-floating halfway-fab bg-primary"><i class="ft-plus"></i></a> -->
          </div>
          <div class="card-body">
            {{ item.about }}
            <div class="row mt-2">
              <div class="col-2 text-center" *ngIf="item?.facebook_url.length>0">
                <a [href]="item.facebook_url" target="_blank">
                  <i class="ft-facebook primary font-large-1 my-3"></i>
                </a>
              </div>
              <div class="col-2 text-center" *ngIf="item?.linked_url.length>0">
                <a [href]="item.linked_url" target="_blank">
                  <i class="ft-linkedin primary font-large-1 my-3"></i>
                </a>
              </div>
              <div class="col-2 text-center" *ngIf="item?.website.length>0">
                <a [href]="item.website" target="_blank">
                  <i class="ft-external-link primary font-large-1 my-3"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12" [hidden]="!totalItems">
    <ngb-pagination class="mt-2 d-flex justify-content-center" [maxSize]="5" [boundaryLinks]="true" [collectionSize]="totalItems" [(page)]="page" [pageSize]="50" (pageChange)="onPageChange($event)" aria-label="Default pagination"></ngb-pagination>
  </div>
</section>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>
<!-- // Weather cards end -->